import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import SearchApp from "@/SearchApp/SearchApp.vue";
import SharedToast from "@/SharedToastApp/SharedToast.vue";
import SharedBanner from "@/SharedBannerApp/SharedBanner.vue";
import EmarsysToast from "@/EmarsysToastApp/EmarsysToast.vue";

import { onMounted, ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'SiteWideApp',
  setup(__props) {

const showSearchApp = ref(false);

onMounted(() => {
	showSearchApp.value = !!(window.ocm?.config?.hasSearch && document.getElementById("header-search-container"));
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (showSearchApp.value)
      ? (_openBlock(), _createBlock(SearchApp, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode(EmarsysToast),
    _createVNode(SharedToast),
    _createVNode(SharedBanner)
  ], 64))
}
}

})